import { Section, Div, ElementProperties, not, if as _if, Button, Br } from 'alkali'
import LoadingEllipsis from 'components/generic/LoadingEllipsis'
import Tabbed, { TabbedState } from 'components/generic/Tabbed'
import ExtractionModel from './model/ExtractionModel'
import EditToggle from './EditToggle'
import MetadataTab from './MetadataTab'
import SummaryTab from 'components/extract/SummaryTab'
import ExtractionTab from './ExtractionTab'
import ExtractAnnotationModel from './ExtractAnnotationModel'
import { DeleteButton, StudyDetails } from './ExtractPane'
import { studiesSearch, studySearchCache } from 'model/EvidenceSearch'

export interface ExtractColOpts extends ElementProperties<ExtractCol> {
	extractionModel: ExtractionModel
	annotModel: ExtractAnnotationModel
	debug?: boolean
}

/**
 * Column containing extraction-related tabs
 */
export default class ExtractCol extends Section('.extract-col') {
	created(props: ExtractColOpts) {
		const { extractionModel, annotModel, debug, study, onSubmit } = props
		const { loading, editToggle } = extractionModel

		let studyDetails  = null;
		if (study) {
			studyDetails =  new StudyDetails(study, app.user)
		}

		const tabbedState = new TabbedState(2)
		props.content = loading.to(loading => [
			loading ? Div('.loading-msg', [
					Div('Analyzing abstract...'),
					LoadingEllipsis()
				]) :
				[new Tabbed({
					classes: { hidden: loading },
					tabbedState,
					leading: Div('.leading', tabbedState.activeIndex.to(i => [
						i == 2 ? new EditToggle({ editing: editToggle }) : undefined
					]))
				}, [ {
					label: 'Study',
					content: new MetadataTab({ extractionModel, focusedState: annotModel.focusedState.valueOf() }),
					config: {
						title: _if(not(extractionModel.summary.isSelfValid), ['Errors exist on this tab']),
						classes: {
							invalid: not(extractionModel.summary.isSelfValid)
						}
					}
				}, {
					// 	label: 'Demographics',
					// 	content: [
					// 		new DemographicsPane({ extraction })
					// 	]
					// }, {
					label: 'Summary',
					content: new SummaryTab({ study: extractionModel.study })
				}, {
					label: 'Outcomes',
					content: editToggle.to(() => new ExtractionTab({ extractionModel, annotModel, activeIndex: tabbedState.activeIndex, debug })),
					config: {
						title: _if(not(extractionModel.isSelfValid), ['Errors exist on this tab']),
						classes: {
							invalid: not(extractionModel.isSelfValid)
						}
					}
				}])
				,
				Br,Br,
				Div('.study-delete-btn', {}, [
					studyDetails?.canDelete ? DeleteButton(study, onSubmit) : null
				])	
			]
		])
	}

}
